import {useEffect, useState} from 'react';
import { jsxActions as fetchEntitiesActions } from '../../../../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as qplTestFormActions} from '../../../../../actions/Administration/MatSettingsPage/qplTestFormActions.js';
import { jsxActions as createQplTestFieldDialogActions} from '../../../../../actions/Administration/MatSettingsPage/Dialogs/createQplTestFieldDialogActions.js';
import useRedux from 'infrastructure/js/hooks/useRedux';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import QplTestForm from './qplTestForm';

const getState = (state) => {
  return {
    qplTestFormData: state.administration.getIn(['matSettingsPage', 'qplTestForm']),
    sLoggedInUser : state.login.get('loggedInUser'),
    dialogData: state.administration.getIn(['matSettingsPage', 'createQplTestFieldDialog']),
  }
}

const allActions = {
  actions: qplTestFormActions,
  fetchEntitiesActions: fetchEntitiesActions,
  createQplTestFieldDialogActions
};


function QplTestFormWrapper (props) {
  const { state, actions } = useRedux(allActions, getState);
  const { qplTestFormData, loading, dialogData } = state;

  const [initialized, setInitialized] = useState(false);
  const [item, setItem] = useState(null);


  useEffect(() => {
    actions.actions.fetchFormData();
    return () => {
      actions.actions.clearFormData();
    }
  }, []);

  useEffect(() => {
    let qplTestId = props.match.params.qplTestId;
    let qplId = props.match.params.qplId;
    if (qplTestId && qplId) {
      actions.actions.fetchFormItem(+qplTestId, +qplId).then(data => {
        if (data) {
          setItem(data);
        }
        setInitialized(true);
      })
    }
    else {
      setInitialized(true);
    }

    return () => {
      actions.actions.clearFormData();
    }
  }, [props.match.params.qplTestId]);

  return  qplTestFormData?.get('formData') && initialized && !loading  ?

    <QplTestForm initialData={item}
             formData={qplTestFormData}
             dialogData={dialogData}
             actions={{...actions.actions, ...actions.fetchEntitiesActions}}
             dialogActions={actions.createQplTestFieldDialogActions}
             {...props } /> :
    <Overlay.Loading />
}

export default QplTestFormWrapper;
